<template>
<div>
    <router-view>
          
    </router-view>
</div>

</template>
<script>
export default {
  name: 'app',
  data() {
    return {
      // 对象属性
    }
  },
  beforeCreate: function() {
    // 创建前状态
  },
  created: function() {
    // 创建完毕状态
  },
  beforeMount: function() {
    // 挂载前状态
  },
  mounted: function() {
    // 挂载结束状态
  },
  beforeUpdate: function() {
    // 更新前状态
  },
  updated: function() {
    // 更新完成状态
  },
  beforeDestroy: function() {
    // 销毁前状态
  },
  destroyed: function() {
    // 销毁完成状态
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/module/survey/app.vue?4427808d